import { render, staticRenderFns } from "./WBSelectField.vue?vue&type=template&id=cc229b4e&scoped=true"
import script from "./WBSelectField.vue?vue&type=script&lang=js"
export * from "./WBSelectField.vue?vue&type=script&lang=js"
import style0 from "./WBSelectField.vue?vue&type=style&index=0&id=cc229b4e&prod&lang=scss"
import style1 from "./WBSelectField.vue?vue&type=style&index=1&id=cc229b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc229b4e",
  null
  
)

export default component.exports